import { useEffect } from "react";

import { onAuthStateChange } from "@/modules/auth/service";

export const useAuthStateChange = () => {
  const eventHandlers = {
    SIGNED_IN: () => {},
    SIGNED_OUT: () => {},
    PASSWORD_RECOVERY: () => {},
    INITIAL_SESSION: () => {},
    TOKEN_REFRESHED: () => {},
    USER_UPDATED: () => {},
  };

  useEffect(() => {
    const { data } = onAuthStateChange((event, session) => {
      eventHandlers[event] && eventHandlers[event](session);
    });

    return () => data.subscription.unsubscribe();
  }, []);

  return {
    onSignedIn(handler) {
      eventHandlers.SIGNED_IN = handler;
    },
    onSignedOut(handler) {
      eventHandlers.SIGNED_OUT = handler;
    },
    onPasswordRecovery(handler) {
      eventHandlers.PASSWORD_RECOVERY = handler;
    },
    onInitialSession(handler) {
      eventHandlers.INITIAL_SESSION = handler;
    },
    onTokenRefreshed(handler) {
      eventHandlers.TOKEN_REFRESHED = handler;
    },
    onUserUpdated(handler) {
      eventHandlers.USER_UPDATED = handler;
    },
  };
};
